export default "__VITE_ASSET__zSsxfZ2I__"